import { render, staticRenderFns } from "./LyoutOrg.vue?vue&type=template&id=2cfb1b5a&"
import script from "./LyoutOrg.vue?vue&type=script&lang=js&"
export * from "./LyoutOrg.vue?vue&type=script&lang=js&"
import style0 from "./LyoutOrg.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports